var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDataLoading)?_c('Loader'):_c('div',[_c('Table',{attrs:{"title":_vm.$t('views.snapshots.title'),"headers":_vm.snapshotsHeaders,"rows":_vm.snapshotsRows,"values":_vm.snapshots}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }